module.exports = __webpack_public_path__ + "img/64.6c3ea00a.png";